<template>
  <div>
    <div class="inputCard">
      <header class="pointer" @click="toggleAccordion()" :style="accordion.features ? '' : 'border-radius:5px 5px 5px 5px'"><i class="mr-2 fa w3-small" :class="accordion.features ? 'fa-chevron-down' : 'fa-chevron-right'"></i>Home Page Features</header>
      <div class="content" v-if="accordion.features">
        <div class="input-row-2 w3-padding-8">
          <label>Enabled</label>
          <div class="w3-right-align">
            <label class="switch">
              <input type="checkbox" v-model="state.siteData.pages.home.sections.features.enabled">
              <span class="slider"></span>
            </label>
          </div>
        </div>
        <template v-if="state.siteData.pages.home.sections.features.enabled">
          <div class="cardRow w3-padding-8">
            <label>Features Type</label>
            <select class="w3-select w3-border" v-model="state.siteData.pages.home.sections.features.type">
              <option value="style1">Style 1</option>
              <option value="style2">Style 2</option>
              <option value="style3">Style 3</option>
            </select>
          </div>

          <!-- Style 1 -->
          <template v-if="state.siteData.pages.home.sections.features.type === 'style1'">
            <div class="input-row w3-padding-8 w3-border-bottom" style="margin-bottom:0;">
              <label class="w3-label">Title</label>
              <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="state.siteData.pages.home.sections.features.style1.title"></tinymce-editor>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Subtitle</label>
              <input v-model="state.siteData.pages.home.sections.features.style1.subtitle" class="w3-input w3-border" />
            </div>

            <div class="input-row w3-padding-8">
                <!-- <label class="w3-label">Features</label> use with cols -->
              <div><!-- class="featureGrid" to split into cols -->
                <div class="featureStyle1SettingsGrid outline w3-padding w3-white w3-margin-bottom" v-for="(feature, key, index) in state.siteData.pages.home.sections.features.style1.items" :key="index">
                  <div>
                    <!-- <label for="icon1" class="w3-label">Icon</label> use with cols -->
                    <div class="w3-black" style="height:100px; width:100px; display: flex; justify-content: center; align-items: center;" @click="setIcon('siteData.pages.home.sections.features.style1.items.' + key + '.icon')">
                      <i style="font-size: 44px;" :class="'fa fa-' + state.siteData.pages.home.sections.features.style1.items[key].icon" :title="state.siteData.pages.home.sections.features.style1.items[key].icon"></i>
                    </div>
                  </div>
                  <div>
                    <div class="w3-row">
                      <label for="title1" class="w3-label">Title</label>
                      <input name="title1" v-model="state.siteData.pages.home.sections.features.style1.items[key].title" placeholder="Title" class="w3-input w3-border" />
                    </div>
                    <div class="w3-row w3-margin-bottom">
                      <label for="text1" class="w3-label">Text</label>
                      <input name="text1" v-model="state.siteData.pages.home.sections.features.style1.items[key].text" placeholder="placeholder text" class="w3-input w3-border" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- Style 2 -->
          <template v-if="state.siteData.pages.home.sections.features.type === 'style2'">
            <div v-for="(item, key, index) in state.siteData.pages.home.sections.features.style2.items" :key="index">
              <h4 class="w3-padding-8 font-weight-bold">Feature {{index+1}}</h4>
              <div class="content">
                <div class="cardRow w3-padding-8" style="border-bottom:0;">
                  <label style="margin-top:6px;">Image (1920x654)</label>
                  <div class="w3-right-align">
                    <label :for="'featureFile' + index" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
                    <input :id="'featureFile' + index" type="file" @change="uploadFeatureImage($event.target.files, key)" ref="fileUpload" accept=".png,.jpg" class="inputFile" />
                  </div>
                </div>
                <div class="w3-center w3-border-bottom w3-padding-bottom">
                  <img v-if="state.siteData.pages.home.sections.features.style2.items[key].src !== ''" :src="state.siteData.pages.home.sections.features.style2.items[key].src" style="width:100%; max-width:300px;" />
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Title</label>
                  <input v-model="state.siteData.pages.home.sections.features.style2.items[key].title" :placeholder="'FEATURE '+ (index+1) +' TITLE'" class="w3-input w3-border" />
                </div>
                <div class="cardRow w3-padding-8 w3-border-bottom">
                  <label>Subtitle</label>
                  <input v-model="state.siteData.pages.home.sections.features.style2.items[key].subtitle" :placeholder="'Feature '+ (index+1) +' Subtitle'" class="w3-input w3-border" />
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Text</label>
                  <input v-model="state.siteData.pages.home.sections.features.style2.items[key].text" :placeholder="'Feature '+ (index+1) +' text...'" class="w3-input w3-border" />
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Button Text</label>
                  <input v-model="state.siteData.pages.home.sections.features.style2.items[key].buttonText" placeholder="More About Us" class="w3-input w3-border" />
                </div>
                <div class="cardRow w3-padding-8">
                  <label>Button URL</label>
                  <input v-model="state.siteData.pages.home.sections.features.style2.items[key].url" placeholder="/about-us" class="w3-input w3-border" />
                </div>
              </div>
            </div>
          </template>
          <!-- Style 3 -->
          <template v-if="state.siteData.pages.home.sections.features.type === 'style3'">
            <div class="input-row w3-padding-8 w3-border-bottom" style="margin-bottom:0;">
              <label class="w3-label">Title</label>
              <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="state.siteData.pages.home.sections.features.style3.title"></tinymce-editor>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Subtitle</label>
              <input v-model="state.siteData.pages.home.sections.features.style3.subtitle" class="w3-input w3-border" />
            </div>

            <div class="input-row w3-padding-8">
                <!-- <label class="w3-label">Features</label> use with cols -->
              <div class="featureGrid"><!-- class="featureGrid" to split into cols -->
                <div class="featureStyle1SettingsGrid outline w3-padding w3-white w3-margin-bottom" v-for="(feature, key, index) in state.siteData.pages.home.sections.features.style3.items" :key="index">
                  <div>
                    <label for="icon1" class="w3-label">Icon</label>
                    <div class="w3-black" style="height:100px; width:100px; display: flex; justify-content: center; align-items: center;" @click="setIcon('siteData.pages.home.sections.features.style3.items.' + key + '.icon')">
                      <i style="font-size: 44px;" :class="'fa fa-' + state.siteData.pages.home.sections.features.style3.items[key].icon" :title="state.siteData.pages.home.sections.features.style3.items[key].icon"></i>
                    </div>
                  </div>
                  <div>
                    <div class="w3-row">
                      <label for="title1" class="w3-label">Title</label>
                      <input name="title1" v-model="state.siteData.pages.home.sections.features.style3.items[key].title" placeholder="Title" class="w3-input w3-border" />
                    </div>
                    <div class="w3-row w3-margin-bottom">
                      <label for="text1" class="w3-label">Text</label>
                      <input name="text1" v-model="state.siteData.pages.home.sections.features.style3.items[key].text" placeholder="placeholder text" class="w3-input w3-border" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
var dataStore = require('@/dataStore').default

export default {
  name: 'cmsslider',
  data() {
    return {
      state: dataStore.state
    }
  },
  props: {
    accordion: Object
  },
  components: {
    'tinymce-editor': Editor
  },
  methods: {
    uploadFeatureImage(files, key) {
      dataStore.uploadImage(files).then((path) => {
        this.state.siteData.pages.home.sections.features.style2.items[key].src = path
      })
    },
    toggleAccordion() {
      this.$emit('toggleAccordion', !this.accordion.features)
    },
    setIcon(which) {
      this.state.modals.iconModal = true
      this.state.selectedIcon = which
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cms/pages/home/cmsFeatures.vue